<template>
  <article>
    <ArticleMastHead
      :title="temple.name"
      :cover_media="templeCoverMedia"
      :identity="temple.identity"
      :space="temple.space"
      :address="temple.address"
      :telephone="temple.telephone"
      :openingInfo="temple.opening_info"
      :articleID="temple.id"
      :referenceType="3"
      :isMobile="isMobile"
    />
    <ArticleContainer>
      <template #main>
        <ArticleParagraphs :category="'temple'">
          <!-- 廟宇基本介紹內容 -->
          <TempleIntro
            :title="temple.title"
            :intro="temple.description"
            :gods="[temple.god1, temple.god2]"
          >
            <TempleGuideImage
              v-if="temple.guide_image_url"
              :guideImageSrc="temple.guide_image_url"
              :templeName="temple.name"
            />
          </TempleIntro>
          <!-- 廟宇導覽位置的藝品說明 -->
          <TempleGuidesAccordion
            :templeGuides="temple.temple_guides"
            @update:toggleTempleGuide="
              $store.commit('toggleTempleGuide', $event)
            "
          />
        </ArticleParagraphs>
      </template>
      <template #aside>
        <TempleAside :isMobile="isMobile" />
      </template>
    </ArticleContainer>
  </article>
</template>

<script>
import ArticleMastHead from '@/components/article/ArticleMastHead';
import ArticleParagraphs from '@/components/article/ArticleParagraphs';
import TempleIntro from '@/components/TempleIntro';
import TempleGuideImage from '@/components/TempleGuideImage';
import TempleGuidesAccordion from '@/components/TempleGuidesAccordion';
import ArticleContainer from '@/components/article/ArticleContainer';
import TempleAside from '@/components/aside/TempleAside';

export default {
  name: 'TheTemple',
  metaInfo() {
    return {
      title: this.temple.name ? `${this.temple.name} - 參觀總覽` : '參觀總覽',
      meta: [
        {
          vmid: 'og:url',
          property: 'og:url',
          content: this.productionWholeReference,
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: `${this.temple.name} | 臺南宗教藝術`,
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: this.temple.description,
        },
        {
          vmid: 'og:image',
          property: 'og:image',
          content: this.temple.cover_image_url,
        },
      ],
    };
  },
  data() {
    return {};
  },
  computed: {
    temple() {
      return this.$store.getters.temple;
    },
    templeCoverMedia() {
      return this.$store.getters.getCoverMedia('temple');
    },
    productionWholeReference() {
      return `${this.$store.getters.productionHostname}${window.location.pathname}${window.location.search}`;
    },
    windowWidth() {
      return this.$store.getters.windowWidth;
    },
    isMobile() {
      return this.windowWidth < 1440;
    },
  },
  async mounted() {
    await this.getTempleData(this.$route.params.articleId);
    // await lazyloading();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.articleId !== from.params.articleId) {
      this.getTempleData(to.params.articleId);
    }
    next();
  },
  methods: {
    async getTempleData(articleId) {
      // 載入藝品文章頁內頁，以 API 資料作為初始值
      try {
        await this.$store.dispatch('getTemple', articleId);
      } catch (e) {
        console.error(e);
      }
    },
  },
  components: {
    ArticleMastHead,
    ArticleParagraphs,
    TempleIntro,
    TempleGuideImage,
    TempleGuidesAccordion,
    ArticleContainer,
    TempleAside,
  },
};
</script>
